import React from "react";
import { Route } from "react-router-dom";
import ConfigDashboard from "../Forms/AppConfig/ConfigDashboard";
import DataDashboard from "../Forms/Data/DataDashboard";
import DataHSign from "../Forms/Data/DataHSign";
import Destek from "../Forms/Destek";
import HomeScreen from "../Forms/HomeScreen";
import HouseSignDashboard from "../Forms/HouseSign.js/HouseSignDashboard";
import HouseSignUpdate from "../Forms/HouseSign.js/HouseSignUpdate";
import KullaniciDetay from "../Forms/KullaniciDetay/KullaniciDetay";
import BolgesiOlmayan from "../Forms/Projects/BolgesiOlmayan";
import HizliTaramaOzet from "../Forms/Projects/HizliTaramaOzet";
import Istatislik from "../Forms/Projects/Istatislik";
import ProjectArea from "../Forms/Projects/ProjectArea";
import ProjectDetay from "../Forms/Projects/ProjectDetay";
import ProjectInfo from "../Forms/Projects/ProjectInfo";
import ProjectSideBar from "../Forms/Projects/ProjectSideBar";
import SignDashboard from "../Forms/Sign/SignDashboard";
import SignUpdate from "../Forms/Sign/SignUpdate";
import Calisma from "../Forms/Statics/Calisma";
import Statistics from "../Forms/Statics/Statistics";
import TasksUpdate from "../Forms/Tasks/TasksUpdate";
import TeamDashboard from "../Forms/Team/TeamDashboard";
import TeamInfo from "../Forms/Team/TeamInfo";
import UsersDashboard from "../Forms/Users/UsersDashboard";
import UsersUpdate from "../Forms/Users/UsersUpdate";
import ShowTable from "../Pages/ShowTable";

export default function ContainRouter() {
  return (
    <div
      className="container-xlarge"
      style={{ border: "1px solid rgb(230, 230, 230)", borderRadius: 4 }}
    >
      <Route exact path="/dashboard">
        <HomeScreen />
      </Route>
      <Route exact path="/dashboard/statics">
        <Statistics />
      </Route>
      <Route exact path="/dashboard/calisma">
        <Calisma />
      </Route>
      <Route exact path="/dashboard/tasks">
        <ProjectSideBar />
      </Route>
      <Route exact path="/dashboard/projeistatislik">
        <Istatislik />
      </Route>
      <Route exact path="/dashboard/hizliTaramaOzet">
        <HizliTaramaOzet />
      </Route>
      <Route exact path="/dashboard/projectBolgesiOlmayan/:id">
        <BolgesiOlmayan />
      </Route>
      <Route exact path="/dashboard/project/:id">
        <ProjectDetay />
      </Route>
      <Route exact path="/dashboard/projectValues/:id">
        <ProjectInfo />
      </Route>
      <Route exact path="/dashboard/projectArea/:id">
        <ProjectArea />
      </Route>
      <Route exact path="/dashboard/task/update/:id">
        <TasksUpdate />
      </Route>
      <Route exact path="/dashboard/users">
        <UsersDashboard />
      </Route>
      <Route exact path="/dashboard/users/update/:id">
        <UsersUpdate />
      </Route>
      <Route exact path="/dashboard/data">
        <DataDashboard />
      </Route>
      <Route exact path="/dashboard/data/hsign">
        <DataHSign />
      </Route>
      <Route exact path="/dashboard/hsign">
        <HouseSignDashboard />
      </Route>
      <Route exact path="/dashboard/hsign/update/:id">
        <HouseSignUpdate />
      </Route>
      <Route exact path="/dashboard/sign">
        <SignDashboard />
      </Route>
      <Route exact path="/dashboard/sign/update/:id">
        <SignUpdate />
      </Route>
      <Route exact path="/dashboard/kullaniciDetay/:id">
        <KullaniciDetay />
      </Route>
      <Route exact path="/dashboard/team">
        <TeamDashboard />
      </Route>
      <Route exact path="/dashboard/team/info/:id">
        <TeamInfo />
      </Route>
      <Route exact path="/dashboard/destek">
        <Destek />
      </Route>
      <Route exact path="/dashboard/config">
        <ConfigDashboard />
      </Route>
      <Route exact path="/dashboard/table">
        <ShowTable />
      </Route>
    </div>
  );
}
